import React from 'react'
import { Link, graphql } from 'gatsby'
import 'tachyons/css/tachyons.css';
import styled from 'styled-components'
import '../layouts/custom.css';
import { Title1, Title2, Title3, Large, Medium, Small, Tiny, Micro, BuddyLink } from "./typography"
import { Divider, SectionFeatured, SectionOuter, SectionContact, SectionTestimonial, SectionFeaturedWork, NavLink, NavLinkList, FooterLink, FooterLinkList, Nav, NavMobile, NavLinkMobile, NavLinkListMobile } from "./section"
import AniLink from 'gatsby-plugin-transition-link/AniLink';
import Fade from 'react-reveal/Fade';

class NavDribbble extends React.Component {
    render() {
      return (
        <div>
          
          <NavMobile>
          <AniLink cover to="/" bg="#C1C1C8" direction="up" duration={0.8} className="db dtc-l v-mid link w-100 w-60-ns tl mb2 mb0-l sans-serif"><Small className="f4 fw6 mb0 mt0 sans-serif c--black1">TheBuddyman</Small></AniLink>
              <NavLinkMobile className="navigation-list">
                {/*<NavLinkListMobile><AniLink cover to="/" bg="#C1C1C8" direction="up" duration={0.8}>Home</AniLink></NavLinkListMobile>*/}
                <NavLinkListMobile><AniLink cover to="about" bg="#0F1724" direction="up" duration={0.8}>About</AniLink></NavLinkListMobile>
                <NavLinkListMobile><AniLink cover to="/work" bg="#0F1724" direction="up" duration={0.8}>Work</AniLink></NavLinkListMobile>
                <NavLinkListMobile><a href="https://medium.com/@thomasbudiman" target="_blank">Writing</a></NavLinkListMobile>
              </NavLinkMobile>
          </NavMobile>
        
          <Nav>
          <AniLink cover to="/" bg="#C1C1C8" direction="up" duration={0.8} className="db dtc-l v-mid link w-100 w-60-ns tc tl-l mb2 mb0-l mb3-ns fl-ns sans-serif"><Small className="f4 fw6 mb0 mt0 sans-serif c--black1">TheBuddyman</Small></AniLink>
            <NavLink className="navigation-list">
              {/*<NavLinkList><AniLink cover to="/" bg="#C1C1C8" direction="up" duration={0.8}>Home</AniLink></NavLinkList>*/}
              <NavLinkList><AniLink cover to="about" bg="#0F1724" direction="up" duration={0.8}>About</AniLink></NavLinkList>
              <NavLinkList><AniLink cover to="/work" bg="#0F1724" direction="up" duration={0.8}>Work</AniLink></NavLinkList>
              <NavLinkList><a href="https://medium.com/@thomasbudiman" target="_blank">Writing</a></NavLinkList>
            </NavLink> 
          </Nav>
        </div>
      )
    }
  }
  
  export default NavDribbble